<template>
    <div>

        <v-card hover color="grey darken-2" :max-height="cardHeight" :min-height="cardHeight">
            <v-card-text class="pa-0">

                <div class="d-flex flex-row pa-2">

                    <!-- CARD IMAGE -->
                    <v-img contain width="300" height="160" class="mt-3" :src="getImageUrl(brand.imageUrls)"></v-img>

                    <!-- CARD TEXT AND BUTTONS -->
                    <v-card flat color="transparent" width="100%" height="180">
                        <v-card-text class="pb-0">
                            <h3>{{ brand.brandName }}</h3>
                        </v-card-text>
                        <v-card-text class="shortDescription pt-2" v-html="filterLinks(brand.shortDescription)">
                        </v-card-text>
                        <v-card-text class="pt-0">
                            <v-btn @click="manageClicked" color="primary">Select</v-btn>

                            <v-btn text @click="editClicked">
                                <v-icon left>mdi-information-outline</v-icon>
                                More info
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </div>

            </v-card-text>
        </v-card>

        <!-- CARD CONFIGURATION DIALOG -->
        <fixed-value-card-selector-dialog
            v-model="fixedValueCardPickerDialogModel"
            :brand="brand">
        </fixed-value-card-selector-dialog>

        <!-- VALUE RANGE CARD CONFIGURATION DIALOG -->
        <variable-value-card-config-dialog
            v-model="rangeValueCardConfigDialogModel"
            :brand="brand">
        </variable-value-card-config-dialog>

        <!-- MORE INFO DIALOG -->
        <tango-card-info-dialog v-model="detailDialogModel"
                                :key="brand.brandKey"
                                :name="brand.brandName"
                                :description="brand.description"
                                :disclaimer="brand.disclaimer"
                                :terms="brand.terms"
                                :redemption-instructions="brand.redemptionInstructions"
        ></tango-card-info-dialog>

        <json v-if="false" :data="detailDialogModel"/>
    </div>

</template>

<script>

import ToolbarPage from '../../../../components/UI/ToolbarPage';
import Json from 'vue-json-pretty';
import FixedValueCardSelectorDialog from "./FixedValueCardSelectorDialog";
import VariableValueCardConfigDialog from "./VariableValueCardConfigDialog";
import TangoCardInfoDialog from "./TangoCardInfoDialog";
import TangoCardItemInterface from "../../ts/TangoCardItemInterface";

export default {

    components: {
        ToolbarPage,
        Json,
        FixedValueCardSelectorDialog,
        VariableValueCardConfigDialog,
        TangoCardInfoDialog
    },

    props: {
        brand: {
            type: TangoCardItemInterface,
            required: true
        }
    },

    data() {
        return {
            cardHeight: 200,
            detailDialogModel: false,
            fixedValueCardPickerDialogModel: false,
            rangeValueCardConfigDialogModel: false,
        }
    },

    computed: {
        isVariableValueCard() {
            if (this.brand.items.length === 1 && this.brand.items[0].valueType === 'VARIABLE_VALUE') {
                return true;
            }
        },
    },

    methods: {

        getImageUrl(urls) {
            return urls['300w-326ppi'];
        },

        manageClicked() {

            if (this.isVariableValueCard) {
                this.rangeValueCardConfigDialogModel = true;
            } else {
                this.fixedValueCardPickerDialogModel = true;
            }
        },

        editClicked() {
            this.detailDialogModel = true;
        },

        filterLinks(html) {
            return html.replace(/<a\b[^>]*>/ig, "").replace(/<\/a>/ig, "");
        },
    }
}
</script>
<style scoped>

.shortDescription {
    overflow-y: hidden;
    height: 100px;
}
</style>